export default "__VITE_ASSET__e8d86506__"